export default "__VITE_ASSET__CL1_t5TO__"